import { Box, Flex } from "@chakra-ui/react";
import { Outlet } from "react-router-dom";
import { Sidebar } from "../Sidebar/Sidebar";

export const Layout = () => {
  return (
    <Flex height="100vh" overflow="hidden" alignItems="stretch">
      <Sidebar />
      <Box width="100%" paddingX="24px" minWidth={0} minHeight={0} overflowY="auto">
        <Outlet />
      </Box>
    </Flex>
  );
};
